// leaflet.markercluster expects a global `L`. Importing this module first guarantees it exists
// before the plugin is evaluated (ES imports run in order).
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

window.L = L;

export default L;
